const SERVICE_NAMES = {
	POSTHOG: "postHog",
	MOENGAGE: "moEngage",
	GOOGLEANALYTICS: "gtm",
};

export default SERVICE_NAMES;
